import React from "react";
import { Card, CardBody, Container, Row, Col } from "reactstrap";
import { getQuestionDetails } from "../../../services/questionService";
import { notifyError } from "../../../utils/utils";
import moment from "moment";

class QuestionDetails extends React.Component {

    constructor(props){
        super(props);
        this.state={
            question: {},
            replies: []
        };

        this.renderReply = this.renderReply.bind(this);
    }
    
    componentDidMount() {
        
        if(this.props.match.params.id) {

            getQuestionDetails(this.props.match.params.id)
            .then(res => {
                const { data } = res;

                // console.log(data);
                if(data.status)
                {
                    this.setState({
                        question: data.question_data,
                        replies: data.replies
                    })
                } else {
                    notifyError(data.message);
                }
            });
        }
        
    }

    renderReply(reply) {

        return(
            <Card outline color="warning" className="border" >
                <CardBody>
                    <Row>
                        <Col lg={9}>
                            <h5><strong> {`${reply["user.first_name"]} ${reply["user.last_name"]}`}: </strong>
                            {reply.reply}</h5>
                        </Col>
                        <Col lg={3} className="pull-right">
                        <div >
                            {moment(reply.createdAt).format("DD-MM-YYYY h:MM:SS A")}
                        </div>
                        </Col>
                    </Row>
                </CardBody>
            </Card>
        )
    }

    render() {
        const { question, replies } = this.state;

        return(
            <React.Fragment>
                   <div className="page-content">
                       <Container>
                           
                           <Card className="p-2">
                               

                               {/* <Card outline color="primary"> */}

                                   <CardBody>
                                        <h3>Question Details</h3>
                                        <hr/>
                                       <Row>
                                           <Col lg={4}>
                                               <h5><strong>No:</strong> {question.question_id}</h5>
                                           </Col>

                                           <Col lg={8}>
                                               <h5><strong>Question: </strong> {question.question}</h5>
                                           </Col>
                                       </Row>
                                       <Row className="mt-4">

                                           <Col lg={4}>
                                                <h5><strong>Created By:</strong></h5> <h5>{question.user && `${question.user.first_name} ${question.user.last_name}`}</h5>
                                           </Col>

                                           <Col lg={4}>
                                                <h5><strong>Topic:</strong></h5> <h5>{question.topic_master ? `${question.topic_master.name}` : "NA"}</h5>
                                           </Col>

                                           <Col lg={4}>
                                                <h5><strong>Sub Topic:</strong></h5> <h5>{question.sub_topic_master ? `${question.sub_topic_master.name}` : "NA"}</h5>
                                           </Col>
                                       </Row>

                                       <Row className="mt-4">

                                            <Col lg={4}>
                                                <h5><strong>Expertise:</strong></h5><h5> {question.expertise_master ? `${question.expertise_master.name}` : "NA"}</h5>
                                            </Col>
                                            <Col lg={4}>
                                                <h5><strong>Sub Expertise:</strong></h5><h5> {question.expertise_master ? `${question.sub_expertise_master.name}` : "NA"}</h5>
                                            </Col>

                                            <Col lg={4}>
                                                <h5><strong>Posted on Message Board:</strong></h5><h5>{question.post_on_msg_board ? "Yes" : "No"}</h5>
                                            </Col>
                                        </Row>

                                        <Row className="mt-4"> 
                                            <Col lg={3}>
                                                <h5><strong>People Expertise</strong></h5><h5>{question.route_to_people_expertise ? "Yes" : "No"}</h5>
                                            </Col>
                                            <Col lg={3}>
                                                <h5><strong>People Topic</strong></h5><h5>{question.route_to_people_topic ? "Yes" : "No"}</h5>
                                            </Col>
                                            <Col lg={3}>
                                                <h5><strong>Yoga Expertise</strong></h5><h5>{question.route_to_yoga_expertise ? "Yes" : "No"}</h5>
                                            </Col>
                                            <Col lg={3}>
                                                <h5><strong>Yoga Topic</strong></h5><h5>{question.route_to_yoga_topic ? "Yes" : "No"}</h5>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4"> 
                                            <Col lg={3}>
                                                <h5><strong>Created Date</strong></h5><h5>{moment(question.createdAt).format("DD-MM-YYYY")}</h5>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">  
                                                <Col lg={4}>
                                                    <strong><h3>Replies</h3></strong>
                                                </Col>
                                            </Row>
                                            <hr/>
                                        <div style={{"maxHeight": "400px", "overflowY" :"scroll"}} >
                                            <div>
                                            {
                                                replies.length > 0 
                                                ?
                                                    replies.map((reply,i) => this.renderReply(reply))
                                                :
                                                    <span className="text-info">
                                                        <strong>There is no Reply for this question.</strong>
                                                    </span>
                                            }
                                            </div>
                                        </div>

                                   </CardBody>

                               {/* </Card> */}
                               
                           </Card>
                       </Container>
                   </div>
            </React.Fragment>   
        )
    }
}

export default QuestionDetails;